import { Row, Col } from 'react-bootstrap';
import { ILocalization } from '../../../../localization/definitions/types';
import SusyButton from '../../../shared/buttons/SusyButton';
import './Slide.css';

interface IMiddleBtnProps {
    onNextClick: () => void;
    onBackClick: () => void;
    btnNextText: string;
    btnBackText: string;
}

const MiddleSlideBtn = ({
    onNextClick,
    onBackClick,
    btnNextText,
    btnBackText,
}: IMiddleBtnProps) => {
    return (
        <div className='d-flex slide-content-btns'>
            <div>
                <SusyButton
                    text={btnBackText}
                    kind='secondary'
                    onClickHandler={onBackClick}
                    dataTestId='back-button'
                />
            </div>
            <div>
                <SusyButton
                    text={btnNextText}
                    onClickHandler={onNextClick}
                    dataTestId='next-button'
                />
            </div>
        </div>
    );
};

interface IFirstBtnProps {
    onClick: () => void;
    btnText: string;
}

const FirstSlideBtn = ({ onClick, btnText }: IFirstBtnProps) => {
    return (
        <div className='d-flex slide-content-btns'>
            <div>
                <SusyButton
                    text={btnText}
                    onClickHandler={onClick}
                    dataTestId='lets-go-button'
                />
            </div>
        </div>
    );
};

interface ILastBtnProps {
    onClick: () => void;
    onBackClick: () => void;
    btnBackText: string;
    btnText: string;
}

const LastSlideBtn = ({
    onClick,
    onBackClick,
    btnText,
    btnBackText,
}: ILastBtnProps) => {
    return (
        <div className='d-flex slide-content-btns'>
            <div>
                <SusyButton
                    text={btnBackText}
                    kind='secondary'
                    onClickHandler={onBackClick}
                    dataTestId='back-button'
                />
            </div>
            <div>
                <SusyButton
                    text={btnText}
                    onClickHandler={onClick}
                    dataTestId='next-button'
                />
            </div>
        </div>
    );
};

interface Props {
    slide: {
        content: JSX.Element;
        image: JSX.Element;
        imgSource?: string;
        index: number;
    };
    numberOfSlides: number;
    onNextBtnClick: () => void;
    onBackBtnClick: () => void;
    onFinishBtnClick: () => void;
    localization: ILocalization;
}

export const Slide = ({
    slide,
    numberOfSlides,
    onNextBtnClick,
    onBackBtnClick,
    onFinishBtnClick,
    localization,
}: Props) => {
    const renderBtn = () => {
        const { slider } =
            localization.localizationStrings.susy.thesisManagement.tutorial;

        if (slide.index === 0) {
            return (
                <FirstSlideBtn
                    onClick={onNextBtnClick}
                    btnText={slider.letsGo}
                />
            );
        }

        if (slide.index === numberOfSlides - 1) {
            return (
                <LastSlideBtn
                    btnBackText={slider.backBtn}
                    onBackClick={onBackBtnClick}
                    onClick={onFinishBtnClick}
                    btnText={slider.finish}
                />
            );
        }

        return (
            <MiddleSlideBtn
                onBackClick={onBackBtnClick}
                onNextClick={onNextBtnClick}
                btnBackText={slider.backBtn}
                btnNextText={slider.nextBtn}
            />
        );
    };

    return (
        <Row
            className='slide-container-row'
            style={{ backgroundImage: `url(${slide.imgSource})` }}
        >
            <Col className='col-12 d-xl-none p-0'>
                <div className='slide-inline-image-container d-xl-none'>
                    <div className='carousel-img'>
                        <img alt='' src={slide.imgSource} />
                    </div>
                </div>
            </Col>
            <Col className='col-12 col-xl-5 p-0 order-1 order-xl-0'>
                <div className='slide-content-column'>
                    {slide.content}
                    {renderBtn()}
                </div>
            </Col>
            <Col className='slide-empty-column col-xl-7 p-0'></Col>
        </Row>
    );
};
